import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceOkOutlineSVG = function FaceOkOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2A14 14 0 112 16 14 14 0 0116 2zm0 2a12 12 0 1012 12A12 12 0 0016 4zm4.5 15.5a1 1 0 01.1 2H11a1 1 0 01-.1-2h9.6zM12 11a2 2 0 11-2 2 2 2 0 012-2zm8 0a2 2 0 11-2 2 2 2 0 012-2z"
  }));
};
FaceOkOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceOkOutlineSVG);